export class StoreLoading {
  static readonly type = '[Store] Loading';
}

export class StoreNotLoading {
  static readonly type = '[Store] Not loading';
}

export class Authorize {
  static readonly type = 'Authorize';
  constructor(public readonly payload: any) {}
}

export class VerifySSO {
  static readonly type = 'Verify SSO';
  constructor(public readonly payload: any) {}
}

export class Login {
  static readonly type = 'Login';
  constructor(public readonly payload: any) {}
}

export class GetPlans {
  static readonly type = 'Get available plans';
}

export class GetProfile {
  static readonly type = 'Get Profile';
  constructor(public readonly payload: any) {}
}

export class GetStores {
  static readonly type = 'Get Store list';
  constructor(public readonly payload: any) {}
}

export class SwitchStore {
  static readonly type = '[STORE] - Switch to new store';
  constructor(public readonly payload: any) {}
}

export class GetTotalSales {
  static readonly type = '[STORE] - Total Sales';
}

export class GetCustomers {
  static readonly type = '[STORE] - Customers';
}

export class GetRecentOrders {
  static readonly type = '[STORE] - Get Recent orders';
}

export class GetTotalOrders {
  static readonly type = '[STORE] - Get Total orders';
}

export class DeleteStore {
  static readonly type = '[STORE] - Delete Store';
  constructor(public readonly payload: any) {}
}

export class SuspendStore {
  static readonly type = '[STORE] - Suspend Store';
  constructor(public readonly payload: any) {}
}

export class ResumeStore {
  static readonly type = '[STORE] - Resume Store';
  constructor(public readonly payload: any) {}
}

export class GetFAQs {
  static readonly type = '[STORE] - Get FAQs';
}

export class GetLanguages {
  static readonly type = '[STORE] - Get Languages';
}

export class UpdateLanguage {
  static readonly type = '[STORE] - Update Languages';
  constructor(public readonly payload: any) {}
}

export class GetStoreInfo {
  static readonly type = '[STORE] - Get Info';
  constructor(public readonly payload: any) {}
}

export class GetStorePreferences {
  static readonly type = '[STORE] - Get Settings';
  constructor(public readonly payload: any) {}
}

export class UpdateCompanyInfo {
  static readonly type = '[STORE] - Update Company Info';
  constructor(public readonly payload: any) {}
}

export class DecryptDealerId {
  static readonly type = '[DEALER] - Decrypt Id';
  constructor(public readonly payload: any) {}
}

export class InvalidDealer {
  static readonly type = 'Invalid Dealer';
}

export class GetTemplates {
  static readonly type = '[STORE] - Get Templates';
}

export class GetCountries {
  static readonly type = '[STORE] - Get Countries';
}

export class GetStates {
  static readonly type = '[STORE] - Get States';
}

export class GetUnits {
  static readonly type = '[STORE] - Get Units';
}

export class UpdateCompanyAddress {
  static readonly type = '[STORE] - Update Company Address';
  constructor(public readonly payload: any) {}
}

export class TimeoutError {
  static readonly type = '[API] - Timeout error';
}

export class GetCurrencies {
  static readonly type = '[STORE] - Get Currencies';
}

export class GetCurrencyFormats {
  static readonly type = '[STORE] - Get Currency formats';
}

export class GetTimezones {
  static readonly type = '[STORE] - Get Timezones';
}

export class GetTimeDisplayFormat {
  static readonly type = '[STORE] - Get Time display format';
}

export class GetDateDisplayFormat {
  static readonly type = '[STORE] - Get Date display format';
}

export class GetProductSortOrder {
  static readonly type = '[STORE] - Get Product sort order';
}

export class GetOrdersInfo {
  static readonly type = '[STORE] - Get Orders Info';
}

export class GetProducts {
  static readonly type = '[STORE] - Get Products Info';
}

export class UpdateSearchResults {
  static readonly type = '[SEARCH] - Update Search Results';
  constructor(public readonly payload: any) {}
}

export class GetNotifications {
  static readonly type = '[STORE] - Get notification list';
  constructor(public readonly payload: any) {}
}

export class GetUnreadNotifications {
  static readonly type = '[STORE] - Get Unread notification list';
}

export class UpdateNotificationItem {
  static readonly type = '[STORE] - Update notification item';
  constructor(public readonly payload: any) {}
}

export class MarkAllNotifAsRead {
  static readonly type = '[STORE] - Mark all notifications as Read';
}

export class MarkItemsAsRead {
  static readonly type = '[STORE] - Mark selected notifications as Read';
  constructor(public readonly payload: any) {}
}

export class FirstTimeUser {
  static readonly type = '[STORE] - First time users';
}
